import { EventType, FilmSessionFragment, FilmTileFragment } from "@generated-types"
import dayjs from "dayjs"
import { generateIcsCalendar, type IcsCalendar } from "ts-ics"

export function downloadIcsFile(
  items: { film: FilmTileFragment; session: FilmSessionFragment }[],
  title: string = "My Watchlist",
) {
  const calendar: IcsCalendar = {
    prodId: "-//sff.org.au//EN",
    version: "2.0",
    name: "Sydney Film Festival",
    method: "PUBLISH",
    timezones: [
      {
        id: "Australia/Melbourne",
        props: [],
        lastModified: new Date(),
      },
    ],
    events: items.map((item) => ({
      uid: item.session.info?.hash!,
      stamp: {
        date: new Date(),
        type: "DATE-TIME",
      },
      start: {
        date: dayjs(item.session.info?.dateTime).toDate(),
        type: "DATE-TIME",
      },
      end: {
        date: dayjs(item.session.info?.dateTime)
          .add(item.film.eventInfo?.runtime ?? 60, "minute")
          .toDate(),
        type: "DATE-TIME",
      },
      url: item.film.uri?.startsWith("/")
        ? `https://www.sff.org.au${item.film.uri}`
        : (item.film.uri ?? "https://www.sff.org.au/"),
      summary: (item.film.eventInfo?.eventType === EventType.Film ? "Film: " : "SFF: ") + item.film.title!,
      description: item.film.descriptions?.short!,
      location: [item.session.info?.venue?.titleSimple, item.session.info?.venue?.titleSub].filter(Boolean).join(" — "),
      geo: item.session.info?.venue?.geo?.replace(",", ";") || undefined,
    })),
  }
  console.log("Generated ICS Calendar:", calendar)
  const icsCalendarString = generateIcsCalendar(calendar)

  const downloadLink = URL.createObjectURL(new Blob([icsCalendarString], { type: "text/calendar" }))
  const linkElement = document.createElement("a")
  linkElement.href = downloadLink
  linkElement.download = `${title}.ics`
  document.body.appendChild(linkElement)
  linkElement.click()
  document.body.removeChild(linkElement)
  URL.revokeObjectURL(downloadLink)
}
